import React from "react";
import { formatCustomDate } from "helpers/dateTools"
import { ModalV2 } from "components/Modal/ModalV2";
import RegularButton from "components/CustomButtons/Button";
import { useToggle } from "hooks/useToggle";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { NationalNotesView } from "./NationalNotesView";
import ShipmentActionsCell from "./ShipmentActionsCell";

export const columnsShipment = [
  {
    Header: "Número embarque",
    accessor: "shipmentNumber",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return row.shipmentNumber.toLowerCase().includes(value);
    },
  },
  {
    Header: "Fecha Factura",
    accessor: "chargeDate",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return row.chargeDate.toLowerCase().includes(value);
    },
    Cell: props => props.value !== null ? formatCustomDate(props.value) : null,
  },
  {
    Header: "Kilos",
    accessor: "kilograms",
    filterable: false,
  },
  {
    Header: "Litros",
    accessor: "liters",
    filterable: false,
  },
  {
    Header: "Centro embarque",
    accessor: "shippingCenter",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return row.shippingCenter.toLowerCase().includes(value);
    },
  },
  {
    Header: "Tanque",
    accessor: "creLicense",
    filterable: true,
    Cell: ({ original }) => (<div> {original?.creLicense ? original?.creLicense : 'Tanque no seleccionado'} </div>),
    filterMethod: ({ value }, row) => {
      return row.creLicense.toLowerCase().includes(value);
    },
  },
  {
    Header: "Transportista",
    accessor: "carrier",
    filterable: true,
    Cell: ({ original }) => (<div> {original?.carrier ? original?.carrier : 'Falta seleccionar'} </div>),
    filterMethod: ({ value }, row) => {
      return row.carrier.toLowerCase().includes(value);
    },
  },
  {
    Header: "PG",
    accessor: "shipperTruck",
    filterable: true,
    Cell: ({ original }) => (<div> {original?.shipperTruck ? original?.shipperTruck : 'Falta seleccionar'} </div>),
    filterMethod: ({ value }, row) => {
      return row.shipperTruck.toLowerCase().includes(value);
    },
  },
  {
    Header: "Notas Nacionales",
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const { id } = original;
      const [openNotes, setOpenNotes] = useToggle();

      return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
          {(original?.nationalNotes?.length > 0) &&
            <RegularButton
              color="transparent"
              round
              onClick={setOpenNotes}
              tooltip="Notas nacionales"
              justIcon
              style={{ float: 'right' }}>
              <VisibilityIcon color="primary" />
            </RegularButton>
          }
          <ModalV2 open={openNotes}
            onClose={setOpenNotes}
            title="Notas nacionales"
            toRight
          >
            <NationalNotesView shipmentId={id} onClose={setOpenNotes} />
          </ModalV2>
        </div>
      );
    },
  },
];

export const columnsShipmentOpen = [
  {
    Header: "Número embarque",
    accessor: "shipmentNumber",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return row.shipmentNumber.toLowerCase().includes(value);
    },
  },
  {
    Header: "Fecha Factura",
    accessor: "chargeDate",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return row.chargeDate.toLowerCase().includes(value);
    },
    Cell: props => props.value !== null ? formatCustomDate(props.value) : null,
  },
  {
    Header: "Kilos",
    accessor: "kilograms",
    filterable: false,
  },
  {
    Header: "Litros",
    accessor: "liters",
    filterable: false,
  },
  {
    Header: "Centro embarque",
    accessor: "shippingCenter",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return row.shippingCenter.toLowerCase().includes(value);
    },
  },
  {
    Header: "Tanque",
    accessor: "creLicense",
    filterable: true,
    Cell: ({ original }) => (<div> {original?.creLicense ? original?.creLicense : 'Falta seleccionar'} </div>),
    filterMethod: ({ value }, row) => {
      return row.creLicense.toLowerCase().includes(value);
    },
  },
  {
    Header: "Transportista",
    accessor: "carrier",
    filterable: true,
    Cell: ({ original }) => (<div> {original?.carrier ? original?.carrier : 'Falta seleccionar'} </div>),
    filterMethod: ({ value }, row) => {
      return row.carrier.toLowerCase().includes(value);
    },
  },
  {
    Header: "PG",
    accessor: "shipperTruck",
    filterable: true,
    Cell: ({ original }) => (
      <div>
        { original?.shipperTruck ? original?.shipperTruck : 'Falta seleccionar'}
      </div>
    ),
    filterMethod: ({ value }, row) => {
      return row.shipperTruck.toLowerCase().includes(value);
    },
  },
  {
    Header: "Acciones",
    sortable: false,
    Cell: ShipmentActionsCell,
  },
];